export default "__VITE_ASSET__C9qw4n_6__"